<div class="top-Close-icon">
  <img class="icon-style" src="/icons/close-kb.svg" mat-dialog-close [width]="20">
</div>

<div class="popup-content">
  <p></p>
  @if ((quoteService.popUpCaller?.calledBy=='SUBMIT')||(quoteService.popUpCaller?.calledBy !=='SUBMITFROMEDIT') ) {
    @if (quoteService.popUpCaller?.calledBy=='SUBMIT') {
      <p class="mb-3 popup-header">
        {{'common.text_quote_submit_not_modifiable_message'|cxTranslate}}{{quoteService.popUpCaller?.id}}
      </p>
    }
  } @else {
    @if ((quoteService.popUpCaller?.calledBy !=='SUBMITFROMEDIT')) {
      <p class="mb-3">
        {{'common.text_quote_cancel_confirmation_modal_title'|cxTranslate|slice:0:-3}}{{quoteService.popUpCaller?.id}}
      </p>
    }
  }

  @if (quoteService.popUpCaller?.calledBy=='SUBMITFROMEDIT') {
    <p class="mb-3 popup-header">
      {{'common.text_quote_submit_confirmation_modal_title'|cxTranslate |
      slice:0:-4}}{{quoteService.popUpCaller?.id}}
    </p>
  }

  @if (quoteService.popUpCaller?.calledBy=='CANCELFROMEDIT') {
    <p class="mb-3">
      {{'common.text_quote_cancel_confirmation_modal_title'|cxTranslate|slice:0:-3}}{{quoteService.popUpCaller?.id}}
    </p>
  }
  <div class="content-section mb-2">
    <div class="popup-text">{{'common.basket_save_cart_name'|cxTranslate}} &nbsp;{{quoteService.popUpCaller?.name}}
    </div>
    <div class="popup-text">
      {{'common.breadcrumb_quote_view'|cxTranslate|slice:0:-3}}{{quoteService.popUpCaller?.id}}
    </div>
    <div class="popup-text">{{'common.text_description'|cxTranslate}}</div>
    <div>{{quoteService.popUpCaller?.description}}</div>
  </div>

  <hr>

    <div class="content-bottom-section mt-4 mb-5">
      @if ((quoteService.popUpCaller?.calledBy=='SUBMIT') || (quoteService.popUpCaller?.calledBy=='SUBMITFROMEDIT')) {
        <p class="popup-text">{{'common.text_quote_submit_not_modifiable_message'|cxTranslate}}</p>
      } @else {
        <p class="popup-text">{{'common.text_quote_cancel_confirmation_message'|cxTranslate}}</p>
      }
    </div>
    <div class="buttonSection">
      <button class="btn btn-blue mb-2" (click)="quoteService.yes = true;yesClicked()"
      mat-dialog-close>{{'common.text_msg1'|cxTranslate}}</button>
      <button class="btn btn-primary" (click)="quoteService.yes = false;"
      mat-dialog-close>{{'common.text_msg2'|cxTranslate}}</button>
    </div>
  </div>